import * as React from 'react';

import {Button} from 'shells/button/button';
import {ButtonMover} from 'shells/button-mover/button-mover';
import {FlashBanner} from 'shells/flash-banner/flash-banner';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Modal} from 'shells/modal/modal';

import {useGetSessionUser} from '../../core/use-get-session-user';
import {useInstanceInfo} from '../../core/use-instance-info';
import {OpenableModals, useOpenableModal} from '../../openable-modals';

import {EmbedAnalyticsModalContent} from './embed-analytics-modal-content';
import {mountAnalyticsHelpForm} from './mount-analytics-help-form';
import {useGetAnalyticsStatus} from './use-get-analytics-status';

export function EmbedAnalyticsModal() {
    const {instance} = useInstanceInfo();
    const {user} = useGetSessionUser();
    const {analyticsStatus} = useGetAnalyticsStatus();
    const {isOpen, onClose} = useOpenableModal(OpenableModals.EMBED_ANALYTICS_MODAL);

    const [isWufooFormMounted, setIsWufooFormMounted] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (isWufooFormMounted) {
            mountAnalyticsHelpForm({
                firstName: user ? user.firstName : undefined,
                lastName: user ? user.lastName : undefined,
                emailAddress:
                    // @ts-expect-error
                    user && user.emailAddresses.length ? user.emailAddresses[0].address : undefined,
                companyName: instance ? instance.companyName : undefined,
            });
        }
    }, [isWufooFormMounted, instance, user]);

    return (
        <Modal
            isOpen={isOpen}
            canClickOutsideToClose={true}
            onClose={onClose}
            minHeight={!isWufooFormMounted ? undefined : 600}
            maxHeight={!isWufooFormMounted ? undefined : 600}
            fitHeight={true}
            waitForMount={true}
            headerText='Embed Nutshell snippet onto your site'
        >
            {isWufooFormMounted ? (
                <div id='wufoo-r143emax0qa3rg2'>
                    <div className='full-width full-height flex align-center justify-center'>
                        <LoadingIcon />
                    </div>
                </div>
            ) : (
                <div className='pb-32'>
                    <StackLegacy spacing={16}>
                        {analyticsStatus ? (
                            <EmbedAnalyticsModalContent analyticsStatus={analyticsStatus} />
                        ) : (
                            <div className='full-width flex align-center justify-center'>
                                <LoadingIcon />
                            </div>
                        )}
                        <FlashBanner isOverlay={false} animate={false} type='info'>
                            <div className='flex justify-sb full-width align-center'>
                                <div>
                                    <b>Need some assistance?</b> Our team is happy to do this for
                                    you
                                </div>
                                <ButtonMover direction='right' size='big'>
                                    <Button
                                        variant='text-primary'
                                        onClick={() => {
                                            setIsWufooFormMounted(true);
                                        }}
                                        size='big'
                                    >
                                        Get started
                                    </Button>
                                </ButtonMover>
                            </div>
                        </FlashBanner>
                    </StackLegacy>
                </div>
            )}
        </Modal>
    );
}
